<template>
  <div class="box">
    <div>
      <ul class="img-box">
        <li v-for="(item, index) of img" :key="index">
          <img class="img" :src="item.url" alt="">
          <p class="img-titie">{{item.title}}</p>
        </li>
      </ul>
    </div>
    <ul class="footer">
      <li v-for="(item, index) in footerArr" :key="index">
        <div v-if="item.type === 'nav'">
          <p>{{item.label}}</p>
          <!-- <ul class="children-box">
            <li v-for="(childrenItem, childrenIndex) in item.children" :key="childrenIndex" @click="toUrl(childrenItem.url)">
              <template v-if="childrenItem.type === 'String'">
                {{childrenItem.label}}
              </template>
              <template v-else-if="childrenItem.type === 'img'">
                <img :src="childrenItem.src" alt="" class="img">
              </template>
            </li>
          </ul> -->
        </div>
        <div v-else-if="item.type === 'line'">
          <p class="line"></p>
        </div>
      </li>
    </ul>
    <p class="footer-bottom">&copy;深圳前海智绘大数据服务有限公司&nbsp;&nbsp;<a href="https://beian.miit.gov.cn">粤ICP备18108442号</a></p>
  </div>
</template>

<script>
import i1 from '../assets/images/brand/1.png'
import i2 from '../assets/images/1.jpg'
import i3 from '../assets/images/2.jpg'
export default {
  data () {
    return {
      img: [
        {url: i3, title: '官方微信公众号'},
        {url: i2, title: '业务咨询'}
      ],
      footerArr: [
        { label: '产品体系',
          type: 'nav',
          children: [
            {label: '场地管理SaaS云平台', url: '/saas', type: 'String'},
            {label: '数据中心', url: '/dataCenter', type: 'String'},
            {label: '物联平台', url: '/association', type: 'String'},
            {label: '智绘简报', url: '/briefing', type: 'String'},
            {label: '聚合支付', url: '/payment', type: 'String'},
            {label: '客流监控', url: '/monitor', type: 'String'}
          ]
        },
        {
          type: 'line'
        },
        { label: '解决方案',
          type: 'nav',
          children: [
            {label: '游乐场', 'url': '/amusement', type: 'String'},
            {label: '设备运营商', 'url': '/equipment', type: 'String'}
          ]
        },
        {
          type: 'line'
        },
        { label: '智绘商城',
          type: 'nav',
          children: [{label: '智绘商城', url: '/mall', type: 'String'}]
        },
        {
          type: 'line'
        },
        { label: '关于智绘',
          type: 'nav',
          children: [
            {label: '公司简介', url: '', type: 'String'},
            {label: '加入我们', url: '', type: 'String'},
            {label: '联系我们', url: '', type: 'String'}
          ]
        },
        {
          type: 'line'
        },
        { label: '咨询服务热线',
          type: 'nav',
          children: [
            {label: '电话：0755-29739988', type: 'String'},
            {src: i1, type: 'img'},
            {label: '扫码关注智绘官方公众号', type: 'String'}
          ]
        }
      ]
    }
  },
  methods: {
    toUrl (url) {
      if (url && url !== this.$route.path) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style scoped>
.box{
  background:rgba(48,51,61,1);
  padding-bottom: 30px;
}
.footer{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 60px 500px 25px;
  text-align: left;
}
.footer>li{
  font-size:14px;
  font-family:PingFang SC;
  font-weight:400;
  line-height:29px;
  color:rgba(255,255,255,.3);
  opacity:1;
}
.footer>li p{
  cursor: pointer;
}
.line{
  width: 2px;
  height: 15px;
  background: rgba(255,255,255,.3);
  cursor: auto !important;
}
.children-box{
  margin-top: 40px;
  text-align: left;
}
.children-box>li{
  font-size:14px;
  font-family:MicrosoftYaHei;
  line-height:29px;
  color:rgba(255,255,255,.3);
  cursor: pointer;
}
.children-box>li:hover{
  color:rgba(255,255,255,1);
}
.footer>li:last-child .children-box>li:hover{
  color:rgba(255,255,255,.3);
}
.footer-bottom{
  font-size:14px;
  font-family:PingFang SC;
  font-weight:400;
  line-height:25px;
  color:rgba(102,102,102,1);
  opacity:1;
  text-align: center;
}
.footer-bottom a{
  color: inherit;
}
.img-box{
  display: flex;
  justify-content: space-between;
  padding: 60px 600px  0;
}
.img{
  width: 250px;
  height: 250px;
  margin-top: 10px;
}
.img-titie{
  font-size:14px;
  font-family:PingFang SC;
  font-weight:400;
  line-height:28px;
  color:rgba(255,255,255,1);
  opacity:1;
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue